/**
 * Linkify Local Partner AI replies for in-app paths.
 */
import { Box, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const INTERNAL_PATHS = [
  '/products',
  '/orders',
  '/ads',
  '/topup',
  '/shop',
  '/settings',
  '/dashboard',
  '/sales',
  '/ai',
  '/notifications-help',
];

function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function tokenize(content) {
  const text = content == null ? '' : String(content);
  const pathAlt = INTERNAL_PATHS.map(escapeRegExp).join('|');
  const re = new RegExp(
    `(https?:\\/\\/[^\\s]+)|(${pathAlt})(?:[\\w\\-./?#=&%]*)`,
    'gi'
  );
  const parts = [];
  let last = 0;
  let m;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push({ type: 'text', value: text.slice(last, m.index) });
    if (m[1]) {
      parts.push({ type: 'ext', value: m[1] });
    } else {
      parts.push({ type: 'int', value: m[0] });
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push({ type: 'text', value: text.slice(last) });
  return parts.length ? parts : [{ type: 'text', value: text }];
}

export default function LpAiMessageBody({
  content,
  invert = false,
  conversationId = '',
  onInternalNavigate,
}) {
  const linkColor = invert ? '#ccfbf1' : '#0f766e';
  const parts = tokenize(content);

  return (
    <Box
      component="span"
      sx={{
        typography: 'body2',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        lineHeight: 1.55,
      }}
    >
      {parts.map((p, i) => {
        if (p.type === 'text') {
          return <span key={i}>{p.value}</span>;
        }
        if (p.type === 'ext') {
          return (
            <MuiLink
              key={i}
              href={p.value}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ fontWeight: 800, color: linkColor }}
            >
              {p.value}
            </MuiLink>
          );
        }
        const to = p.value.startsWith('/') ? p.value : `/${p.value}`;
        return (
          <MuiLink
            key={i}
            component={RouterLink}
            to={to}
            state={{
              fromGosnelAi: true,
              conversationId: conversationId || undefined,
            }}
            underline="hover"
            sx={{ fontWeight: 800, color: linkColor, cursor: 'pointer' }}
            onClick={() => {
              try {
                if (conversationId) {
                  localStorage.setItem('lp_gosnel_ai_conversation_id', conversationId);
                }
              } catch {
                /* ignore */
              }
              onInternalNavigate?.(to);
            }}
          >
            {p.value}
          </MuiLink>
        );
      })}
    </Box>
  );
}
